export default "__VITE_ASSET__BSye2XVA__"